<div id="contenedor">
    <div style="margin: 0 auto;border-radius: 4px; border: solid 0px rgba(144, 144, 144, 0.25); padding: 0px 0px 0px 0px;">
        <div class="contenedo" style="height: 83px;">
            <div id="nav1">
                <img id="logoclc" class="nav"  src="../assets/images/fondo_cabezote_agendamiento.jpg" />
            <div class="pull-right">
                <img id="logoclt" style="transform: translate(-5%, -100%);" src="../assets/images/logo_cliente_agentamiento2.png" />
          </div>
              <div class="pull-right">
                <img  *ngIf="idcliente==1" style="width: 80px;padding-top: 10px;padding-right: 10px; transform: translate(270%, -110%)" id="logocl" src="../assets/images/claro.jpg" />
                <img  *ngIf="idcliente!=2" style="width: 90px;padding-top: 10px; margin-right: 10px; padding-right: 10px; transform: translate(270%, -110%)" id="logocl" src="../assets/images/logoetb.png" />
                <img  *ngIf="idcliente ==3" style="width: 110px;padding-top: 10px; margin-right: 50px; padding-right: 10px; transform: translate(270%, -110%)" id="logocl" src="../assets/images/logotu.png" />
              </div>
          </div>
        </div>
        <div class="separador"></div>
    </div>
    </div>
    <br />
<div class="col-lg-10 col-lg-offset-1">
        <div class="jumbotron">
            <h2>{{titulo}}</h2>
            <p>La pagina que intentas cargar no existe<br>
            </p>
            <!--[routerLink]="['/insert-Shedule']" -->
            <a  href="http://www.woden.com.co"  class="btn btn-success">Ingresar de nuevo</a>
        
        </div>
    </div>